export default __webpack_public_path__ + "static/media/0019.f9789982.png";